import { render, staticRenderFns } from "./EdutalkPrizeDraw.vue?vue&type=template&id=328a195f&scoped=true"
import script from "./EdutalkPrizeDraw.vue?vue&type=script&lang=js"
export * from "./EdutalkPrizeDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a195f",
  null
  
)

export default component.exports